import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxInnerFn = /* @__PURE__ */ createRecipe('checkbox-inner', {}, [])

const checkboxInnerVariantMap = {}

const checkboxInnerVariantKeys = Object.keys(checkboxInnerVariantMap)

export const checkboxInner = /* @__PURE__ */ Object.assign(memo(checkboxInnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxInner',
  __getCompoundVariantCss__: checkboxInnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxInnerVariantKeys,
  variantMap: checkboxInnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxInnerVariantKeys)
  },
  getVariantProps: checkboxInnerFn.getVariantProps,
})